<template>
  <div class="m-tab-group">
    <div class="m-tab-group__tab" v-for="tab in tabs" :key="tab.value">
      <input
        class="m-tab-group__ip"
        type="radio"
        :id="getHtmlId(tab.value)"
        :value="tab.value"
        v-model="ipValue"
      />
      <label class="m-tab-group__label" :for="getHtmlId(tab.value)">{{
        tab.label
      }}</label>
    </div>
  </div>
</template>

<script>
/* using v-model with child components: https://stackoverflow.com/a/47312172 */
export default {
  name: "TabGroup",
  props: {
    tabs: Array,
    ipName: String,
    value: String,
  },
  computed: {
    ipValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getHtmlId(tabValue) {
      return `${this.ipName}_${tabValue}`;
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/m-tab-group";
</style>
